import { AppProvider } from '@/contexts/app-context';
import { ThemeProvider } from '@/contexts/theme-context';
import { LayoutProvider } from '@/contexts/layout-context';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { Toaster } from 'sonner';
import { CheckCircle2, ShieldAlert, AlertTriangle, Info } from 'lucide-react';
import 'sonner/dist/styles.css';

export default function App() {
  return (
    <AppProvider>
      <ThemeProvider>
        <LayoutProvider>
          <Toaster
            position="top-right"
            visibleToasts={5}
            closeButton
            expand={true}
            icons={{
              success: (
                <div className="mr-3 w-8 h-8 rounded-full bg-green-100 dark:bg-green-500/10 border border-green-200 dark:border-green-500/20 flex items-center justify-center flex-shrink-0">
                  <CheckCircle2 className="w-4.5 h-4.5 text-green-600 dark:text-green-500" strokeWidth={2} />
                </div>
              ),
              error: (
                <div className="mr-3 w-8 h-8 rounded-full bg-red-100 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 flex items-center justify-center flex-shrink-0">
                  <ShieldAlert className="w-4.5 h-4.5 text-red-600 dark:text-red-500" strokeWidth={2} />
                </div>
              ),
              warning: (
                <div className="mr-3 w-8 h-8 rounded-full bg-orange-100 dark:bg-orange-500/10 border border-orange-200 dark:border-orange-500/20 flex items-center justify-center flex-shrink-0">
                  <AlertTriangle className="w-4.5 h-4.5 text-orange-600 dark:text-orange-500" strokeWidth={2} />
                </div>
              ),
              info: (
                <div className="mr-3 w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <Info className="w-4.5 h-4.5 text-blue-600 dark:text-blue-500" strokeWidth={2} />
                </div>
              ),
            }}
            toastOptions={{
              classNames: {
                toast: 'group toast !bg-white/70 dark:!bg-slate-900/40 !backdrop-blur-xl !border-slate-200 dark:!border-slate-800/80 !rounded-2xl !shadow-[0_8px_32px_0_rgba(0,0,0,0.04)] dark:!shadow-[0_8px_32px_0_rgba(0,0,0,0.2)] !text-slate-900 dark:!text-slate-100 !p-4 !flex !items-center !gap-4 !border transition-all duration-300',
                title: '!text-sm !font-semibold !text-slate-900 dark:!text-white',
                description: '!text-xs !text-slate-500 dark:!text-slate-400',
                closeButton: '!bg-white dark:!bg-slate-800 !border-slate-200 dark:!border-slate-700 !text-slate-400 hover:!text-slate-600 dark:hover:!text-slate-200 !top-2 !right-2 !left-auto !transform-none',
              }
            }}
          />
          <RouterProvider router={router} />
        </LayoutProvider>
      </ThemeProvider>
    </AppProvider>
  );
}
